// Mock data for numerical data

export const MockNUMdata = [
    { date: "2025-08-02", previous: 105, forecast: 95, actual: 100 },
    { date: "2025-07-02", previous: 143, forecast: 70, actual: 105 },
    { date: "2025-06-02", previous: 220, forecast: 160, actual: 143 },
    { date: "2025-05-02", previous: 187, forecast: 210, actual: 220 },
    { date: "2025-04-02", previous: 145, forecast: 200, actual: 187 },
    { date: "2025-03-02", previous: 132, forecast: 150, actual: 145 },
    { date: "2025-02-02", previous: 158, forecast: 140, actual: 132 },
    { date: "2025-01-02", previous: 170, forecast: 160, actual: 158 },
    { date: "2024-12-02", previous: 190, forecast: 180, actual: 170 },
    { date: "2024-11-02", previous: 185, forecast: 195, actual: 190 },
    { date: "2024-10-02", previous: 175, forecast: 180, actual: 185 },
    { date: "2024-09-02", previous: 160, forecast: 170, actual: 175 },
    { date: "2024-08-02", previous: 150, forecast: 155, actual: 160 },
    { date: "2024-07-02", previous: 140, forecast: 145, actual: 150 },
    { date: "2024-06-02", previous: 135, forecast: 138, actual: 140 },
    { date: "2024-05-02", previous: 128, forecast: 130, actual: 135 },
    { date: "2024-04-02", previous: 125, forecast: 127, actual: 128 },
    { date: "2024-03-02", previous: 118, forecast: 120, actual: 125 },
    { date: "2024-02-02", previous: 110, forecast: 115, actual: 118 },
    { date: "2024-01-02", previous: 105, forecast: 108, actual: 110 },
    { date: "2023-12-02", previous: 102, forecast: 104, actual: 105 },
    { date: "2023-11-02", previous: 98, forecast: 100, actual: 102 },
    { date: "2023-10-02", previous: 95, forecast: 97, actual: 98 },
    { date: "2023-09-02", previous: 93, forecast: 94, actual: 95 },
    { date: "2023-08-02", previous: 90, forecast: 92, actual: 93 }
];

export default MockNUMdata;
